

import React from "react";
import "./Prev_Btn.css";

const Prev_Btn = ({
  text = "Click Me",
  onClick,
  type = "button",
  className = "",
}) => {
  return (
    <div className="Prev_Btn_div">
      <button type={type} className={`Prev_Btn ${className}`} onClick={onClick}>
        {text}
      </button>
    </div>
  );
};

export default Prev_Btn;
